import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "{sub1} - Sub ID 1", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "{sub2} - Sub ID 2", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "{sub3} - Sub ID 3", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "{sub4} - Sub ID 4", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "{sub5} - Sub ID 5", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "{sub6} - Sub ID 6", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "{sub7} - Sub ID 7", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDialog) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row justify-between items-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('reference')), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  icon: "close",
                  flat: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('postback_setting_info')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('params')) + ":", 1),
              _createElementVNode("p", null, "{event} - " + _toDisplayString(_ctx.$t('event_type')), 1),
              _createElementVNode("p", null, "{payout} - " + _toDisplayString(_ctx.$t('amount_sum')), 1),
              _createElementVNode("p", null, "{currency} - " + _toDisplayString(_ctx.$t('amount_currency')), 1),
              _createElementVNode("p", null, "{revshare_payout} - " + _toDisplayString(_ctx.$t('general_income_revshare')), 1),
              _createElementVNode("p", null, "{campaign_id} - " + _toDisplayString(_ctx.$t('id_campaign')), 1),
              _createElementVNode("p", null, "{conversion_id} - " + _toDisplayString(_ctx.$t('conversion_id')), 1),
              _createElementVNode("p", null, "{offer_id} - " + _toDisplayString(_ctx.$t('id_offer')), 1),
              _createElementVNode("p", null, "{offer_name} - " + _toDisplayString(_ctx.$t('offer_name')), 1),
              _createElementVNode("p", null, "{status} - " + _toDisplayString(_ctx.$t('all_status')), 1),
              _createElementVNode("p", null, "{deposit_id} - " + _toDisplayString(_ctx.$t('deposit_id')), 1),
              _createElementVNode("p", null, "{datetime} - " + _toDisplayString(_ctx.$t('unix_timestamp')), 1),
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                flat: "",
                label: "OK",
                color: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}